import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const List = lazy(() => import('./JournalsListPage'));
const Detail = lazy(() => import('./JournalDetailPage'));
const Form = lazy(() => import('./JournalFormPage'));
const Recurring = lazy(() => import('./RecurringJournalsPage'));

const routes: RouteObject[] = [
  { path: '/journal-entries', element: <Guard any={['je.read']}><List /></Guard> },
  { path: '/journal-entries/recurring', element: <Guard any={['je.read']}><Recurring /></Guard> },
  { path: '/journal-entries/new', element: <Guard any={['je.create']}><Form /></Guard> },
  { path: '/journal-entries/:id', element: <Guard any={['je.read']}><Detail /></Guard> },
  { path: '/journal-entries/:id/edit', element: <Guard any={['je.create']}><Form /></Guard> },
];
export default routes;
